import script from "./PageNotFound.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageNotFound.vue?vue&type=script&lang=ts&setup=true"

import "./PageNotFound.vue?vue&type=style&index=0&id=855ced14&lang=sass"

const __exports__ = script;

export default __exports__